// utils.js
var DKT = DKT || {};
DKT.utils = function(actualLanguage) {
  function getFormattedDateOnlyTime(date) {
    var preHours = date.getHours();
    var preMinutes = date.getMinutes();
    var hours = preHours < 10 ? "0" + preHours : "" + preHours;
    var minutes = preMinutes < 10 ? "0" + preMinutes : "" + preMinutes;

    return hours + ":" + minutes;
  }

  function getFormattedDateOnlyDayAndMonth(date) {
    var preMonth = date.getMonth() + 1;
    var preDay = date.getDate();
    var month;

    switch (preMonth) {
      case 1:
        month = actualLanguage === "es-ES" ? "ene" : "urt";
        break;
      case 2:
        month = actualLanguage === "es-ES" ? "feb" : "ots";
        break;
      case 3:
        month = actualLanguage === "es-ES" ? "mar" : "mar";
        break;
      case 4:
        month = actualLanguage === "es-ES" ? "abr" : "apr";
        break;
      case 5:
        month = actualLanguage === "es-ES" ? "may" : "mai";
        break;
      case 6:
        month = actualLanguage === "es-ES" ? "jun" : "eka";
        break;
      case 7:
        month = actualLanguage === "es-ES" ? "jul" : "uzt";
        break;
      case 8:
        month = actualLanguage === "es-ES" ? "ago" : "abu";
        break;
      case 9:
        month = actualLanguage === "es-ES" ? "sep" : "ira";
        break;
      case 10:
        month = actualLanguage === "es-ES" ? "oct" : "urr";
        break;
      case 11:
        month = actualLanguage === "es-ES" ? "nov" : "aza";
        break;
      case 12:
        month = actualLanguage === "es-ES" ? "dic" : "abe";
        break;
    }

    return preDay + " " + month;
  }

  function isSameDay(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  // https://stackoverflow.com/a/27943
  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }

    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  return {
    getFormattedDateOnlyTime: getFormattedDateOnlyTime,
    getFormattedDateOnlyDayAndMonth: getFormattedDateOnlyDayAndMonth,
    isSameDay: isSameDay,
    getDistanceFromLatLonInKm: getDistanceFromLatLonInKm
  };
};
